module.exports = __webpack_public_path__ + "img/boissons.3850abc5.png";